import {Directive, EventEmitter, HostListener, Inject, Input, Output} from '@angular/core';
import {NG_VALIDATORS, Validator} from '@angular/forms';

@Directive({
  selector: '[emsCharacterLimit]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: CharacterLimitDirective, multi: true}
  ]
})
export class CharacterLimitDirective implements Validator {

  constructor(@Inject('commonConstants') public commonConstants) {
  }

  calValue: any;
  @Input() charMaxLimit;
  @Input() uppercaseRequired;
  @Output() emsCharacterLimitCheck = new EventEmitter<boolean>();

  @HostListener('input', ['$event'])
  onKeyUp(event: Event) {
    if (this.uppercaseRequired) {
      const inputElement = event.target as HTMLInputElement;
      inputElement.value = inputElement.value.toUpperCase();
    }
  }

  validate() {
    this.calValue = this.charMaxLimit - (this.charMaxLimit / this.commonConstants.charLimitValues.tenPercent);
    this.emsCharacterLimitCheck.emit(this.calValue);
    return null;
  }
}
